<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="173" height="173" viewBox="0 0 173 173">
        <defs>
            <clipPath id="clip-Round">
                <rect width="173" height="173"/>
            </clipPath>
        </defs>
        <g id="Round" clip-path="url(#clip-Round)">
            <circle id="Ellipse_1588" data-name="Ellipse 1588" cx="83.753" cy="83.753" r="83.753" transform="translate(3.578 2.25)" :fill="color" opacity="0.153"/>
            <circle id="Ellipse_1589" data-name="Ellipse 1589" cx="70.868" cy="70.868" r="70.868" transform="translate(16.465 15.135)" :fill="color" opacity="0.179"/>
            <circle id="Ellipse_1590" data-name="Ellipse 1590" cx="57.983" cy="57.983" r="57.983" transform="translate(29.347 28.019)" :fill="color" opacity="0.201"/>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ProfilePictureBackground',
    mixins: [Colorable],
};
</script>
